import React from "react";
import { InventoryInFormModal } from "../InventoryInFormModal";

export function WarrantyReplacementFromVendorModal({ open, onOpenChange, onSuccess }) {
  return (
    <InventoryInFormModal
      open={open}
      onOpenChange={onOpenChange}
      onSuccess={onSuccess}
      sourceType="Warranty_Replacement_From_Vendor"
      labelKey="inventory.warrantyReplacementFromVendor"
    />
  );
}
